























module.exports =
  name: 'settings'
  computed:
    user: -> @$store.state.user
    payment_plan: -> @$store.getters.payment_plan
    link: -> (page) ->
      page = "mobile_#{page}" if HM.is_mobile
      page
